module.exports = __webpack_public_path__ + "img/example-1.2d0f6a84.png";